// Video-embed click-to-load (inventory 3.12). No autoplay before the
// click; YouTube loads via youtube-nocookie.com only after consent by
// interaction. Multi-instance via [data-th-video] with data-youtube-id
// or data-src (+ optional data-captions / data-poster) on the poster
// button. React twin: components/video-embed/VideoEmbed.tsx.
function initVideo(): void {
  document.querySelectorAll<HTMLElement>('[data-th-video]').forEach((video) => {
    const stage = video.querySelector<HTMLElement>('.th-video__stage');
    const poster = video.querySelector<HTMLButtonElement>('.th-video__poster');
    if (!stage || !poster) {
      return;
    }
    poster.addEventListener('click', () => {
      const title = poster.dataset.title ?? 'Video';
      const youtubeId = poster.dataset.youtubeId;
      let frame: HTMLElement;
      if (youtubeId) {
        const iframe = document.createElement('iframe');
        iframe.className = 'th-video__frame';
        iframe.title = title;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        iframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1`;
        frame = iframe;
      } else {
        const element = document.createElement('video');
        element.className = 'th-video__frame';
        element.controls = true;
        element.autoplay = true;
        element.src = poster.dataset.src ?? '';
        if (poster.dataset.poster) {
          element.poster = poster.dataset.poster;
        }
        if (poster.dataset.captions) {
          const track = document.createElement('track');
          track.kind = 'captions';
          track.src = poster.dataset.captions;
          track.srclang = 'de';
          track.label = 'Deutsch';
          track.default = true;
          element.appendChild(track);
        }
        frame = element;
      }
      stage.replaceChildren(frame);
    });
  });
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initVideo) : initVideo();
